import React, { createContext, useContext, useState } from 'react';

const AlertContext = createContext();

export const useAlerts = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlerts must be used within AlertProvider');
    }
    return context;
};

export const AlertProvider = ({ children }) => {
    const [unreadCount, setUnreadCount] = useState(0);

    return (
        <AlertContext.Provider value={{ unreadCount, setUnreadCount }}>
            {children}
        </AlertContext.Provider>
    );
};
